import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut
} from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";

// --- Configuration Firebase ---
const firebaseConfig = {
  apiKey: "AIzaSyCgGLHfXe-o43vWm4PJMxDYcQoUXBEf4wg",
  authDomain: "my-seminar-ecf1a.firebaseapp.com",
  projectId: "my-seminar-ecf1a",
  storageBucket: "my-seminar-ecf1a.appspot.com",
  messagingSenderId: "305647803912",
  appId: "1:305647803912:web:cd23739f878ef5b6a17bbd",
  measurementId: "G-G2EYPSWL4Y"
};

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Exportations pour utilisation dans d'autres fichiers
export {
    auth,
    db,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    onAuthStateChanged,
    signOut,
    doc,
    setDoc
};